import { render, staticRenderFns } from "./ManageBillingAddress.vue?vue&type=template&id=2c9fce3c&"
import script from "./ManageBillingAddress.vue?vue&type=script&lang=js&"
export * from "./ManageBillingAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports